import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({
  name: 'get',
  pure: true,
  standalone: false,
})
export class GetPipe implements PipeTransform {
  transform(item: any, keyPath: any): any {
    return get(item, keyPath);
  }
}
